export default {"src":"/_next/static/media/facebook-white.5d657bc8.svg","height":12,"width":12};